import React from "react";
import PropTypes from "prop-types";
import { InputField } from "../../FormField";
import { RadioField } from "../../FormField";

const RadioButtonGroup = props => {
  const style = { ...props.style };
  const elements = [];
  let key = 0;

  elements.push(
    <td style={style} key={key}>
      {props.questionNumber ? props.questionNumber : ""}
    </td>
  );
  key += 1;

  if (props.field) {
    const { fieldName } = props.field;

    elements.push(
      <td style={style} key={key}>
        {props.questionDesc}
        <InputField name={fieldName} {...props.field} />
      </td>
    );
  } else {
    elements.push(
      <td style={style} key={key}>
        {props.questionDesc}
      </td>
    );
  }
  key += 1;

  for (let col = 0; col < props.columns.length; col++) {
    for (let opt = 0; opt < props.options.length; opt++) {
      elements.push(
        <td key={key}>
          <RadioField
            key={key}
            radioValue={props.options[opt]}
            name={`${props.columns[col]}${props.questionId}`}
            style={{
              textAlign: "center",
              ...props.style,
            }}
            {...props.data[`${props.columns[col]}${props.questionId}`]}
          />
        </td>
      );
      key += 1;
    }
  }

  return <tr>{elements}</tr>;
};

RadioButtonGroup.propTypes = {
  data: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  questionNumber: PropTypes.number,
  questionId: PropTypes.string.isRequired,
  questionDesc: PropTypes.string,
  style: PropTypes.object,
};

export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/common/RadioButtonGroup.js